import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3" }
const _hoisted_2 = { class: "text-lg truncate" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "flex flex-col gap-2" }
const _hoisted_5 = { class: "rounded-md space-y-3 pb-3" }
const _hoisted_6 = {
  key: 4,
  class: "flex flex-col gap-2"
}
const _hoisted_7 = { class: "max-w-max" }
const _hoisted_8 = {
  key: 1,
  class: "space-y-5 p-6"
}

import type { PageSection } from "@/apps/page/page.interfaces";
import {
    BlockDefinition,
    BlockDefinitionGroup,
    BlockDefWithType,
} from "@/apps/page/services/blocks/block.interfaces";
import { useBlocks } from "../../../../services/blocks/useBlocks";
import { useFocusOnEditSection } from "../../../../services/useFocusOnEditSection";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { BlockBaseElement, BlockDataValue } from "@/views/blocks/PageBlock.interface";
import { ButtonSecondaryIconSm, ButtonTertiaryIconXs } from "@easy/ui/buttons";
import { CardToggle, CardToggleAlt } from "@easy/ui/cards";
import {
    FormInput,
    FormRichText,
    FormSelect,
    FormInputQuantity,
    FormLabel,
    FormSwitch,
} from "@easy/ui/forms";
import { ArrowLeftIcon, InvisibleIcon, VisibleIcon } from "@easy/ui/icons";
import { PageSidebar } from "@easy/ui/page-components";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import BlockImage from "./BlockImage.vue";
import GroupItems from "./GroupItems.vue";
import { BlockTypeGroup } from "@/apps/page/services/blocks/block.interfaces";
import PageColors from "@/apps/page/project/sidebar/sections/PageColors.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditBlock',
  props: {
    section: {}
  },
  emits: ["saveBlock", "cancelBlock"],
  setup(__props: any, { emit: __emit }) {



const { getBlockWithTypeMetadata, groupTypes } = useBlocks();
const blockWithMetadata = computed<BlockDefWithType | null>(() =>
    __props.section.typeId ? getBlockWithTypeMetadata(__props.section.typeId) : null
);

const emit = __emit;

const groupedDataFields = computed(() => {
    return groupTypes.reduce<
        Record<BlockDefinitionGroup, BlockDefinition<BlockBaseElement<BlockDataValue>>[]>
    >(
        (
            acc: Record<BlockDefinitionGroup, BlockDefinition<BlockBaseElement<BlockDataValue>>[]>,
            type: BlockTypeGroup
        ) => {
            const fields =
                blockWithMetadata.value?.block?.dataFields.filter(
                    (field) => field.group === type.group
                ) ?? [];

            acc[type.group] = fields;

            return acc;
        },
        {} as Record<BlockDefinitionGroup, BlockDefinition<BlockBaseElement<BlockDataValue>>[]>
    );
});

const { t } = useI18n();

const saveBlock = async () => {
    if (!__props.section._created) {
        __props.section._changed = true;
    }
    emit("saveBlock");
};

const saveButtonText = computed(() => t("shared.save"));

const tabs = computed(() => [
    {
        label: "Content",
        value: "content",
    },
    {
        label: "Styles",
        value: "styles",
    },
]);

const selectedTab = ref("content");

useFocusOnEditSection();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PageSidebar), null, {
    sidebarTitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ButtonSecondaryIconSm), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancelBlock')))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeftIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("page.sections.edit_section")) + " - " + _toDisplayString(blockWithMetadata.value?.blockType.title), 1)
      ])
    ]),
    sidebarMain: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(FormSwitch), {
          modelValue: selectedTab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTab).value = $event)),
          options: tabs.value
        }, null, 8, ["modelValue", "options"])
      ]),
      (selectedTab.value === 'content')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(groupTypes), (groupType) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: groupType.group
            }, [
              (groupedDataFields.value[groupType.group].length > 0)
                ? (_openBlock(), _createBlock(_unref(CardToggle), {
                    key: 0,
                    title: groupType.name
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedDataFields.value[groupType.group], (groupedField) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: groupedField.value
                          }, [
                            (groupedField.groupType === 'multiple')
                              ? (_openBlock(), _createBlock(GroupItems, {
                                  key: 0,
                                  "grouped-field": groupedField,
                                  section: _ctx.section,
                                  "group-icon": groupType.icon
                                }, null, 8, ["grouped-field", "section", "group-icon"]))
                              : _createCommentVNode("", true),
                            (groupedField.groupType === 'single')
                              ? (_openBlock(), _createBlock(_unref(CardToggleAlt), {
                                  key: 1,
                                  "data-field": groupedField.value,
                                  title: groupedField.label,
                                  icon: groupType.icon,
                                  class: _normalizeClass({
                                            'opacity-50':
                                                _ctx.section.dataValues[groupedField.value].isHidden,
                                        })
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_5, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedField.fields, (field) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: field.value
                                        }, [
                                          (field.type === 'text')
                                            ? (_openBlock(), _createBlock(_unref(FormInput), {
                                                key: 0,
                                                id: field.value,
                                                title: field.label,
                                                modelValue: 
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ) = $event)
                                              }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true),
                                          (field.type === 'select')
                                            ? (_openBlock(), _createBlock(_unref(FormSelect), {
                                                key: 1,
                                                modelValue: 
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ) = $event),
                                                label: field.label,
                                                options: field.options,
                                                value: 
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "options", "value"]))
                                            : _createCommentVNode("", true),
                                          (field.type === 'html')
                                            ? (_openBlock(), _createBlock(_unref(FormRichText), {
                                                key: 2,
                                                id: field.value,
                                                title: field.label,
                                                modelValue: 
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ) = $event),
                                                rows: field.rows
                                              }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue", "rows"]))
                                            : _createCommentVNode("", true),
                                          (field.type === 'image')
                                            ? (_openBlock(), _createBlock(BlockImage, {
                                                key: 3,
                                                id: field.value,
                                                title: field.label,
                                                modelValue: 
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                                            _ctx.section.dataValues[groupedField.value]
                                                                .data[
                                                                field.value as keyof BlockDataValue
                                                            ]
                                                        ) = $event)
                                              }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true),
                                          (field.type === 'slider')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createVNode(_unref(FormLabel), null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(field.label), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createElementVNode("div", _hoisted_7, [
                                                  _createVNode(_unref(FormInputQuantity), {
                                                    title: field.label,
                                                    modelValue: 
                                                                    _ctx.section.dataValues[
                                                                        groupedField.value
                                                                    ].data[
                                                                        field.value as keyof BlockDataValue
                                                                    ]
                                                                ,
                                                    "onUpdate:modelValue": ($event: any) => ((
                                                                    _ctx.section.dataValues[
                                                                        groupedField.value
                                                                    ].data[
                                                                        field.value as keyof BlockDataValue
                                                                    ]
                                                                ) = $event)
                                                  }, null, 8, ["title", "modelValue", "onUpdate:modelValue"])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  actions: _withCtx(() => [
                                    _createVNode(_unref(ButtonTertiaryIconXs), {
                                      onClick: ($event: any) => (
                                                    _ctx.section.dataValues[
                                                        groupedField.value
                                                    ].isHidden =
                                                        !_ctx.section.dataValues[groupedField.value]
                                                            .isHidden
                                                )
                                    }, {
                                      default: _withCtx(() => [
                                        (
                                                        !_ctx.section.dataValues[groupedField.value]
                                                            .isHidden
                                                    )
                                          ? (_openBlock(), _createBlock(_unref(VisibleIcon), { key: 0 }))
                                          : (_openBlock(), _createBlock(_unref(InvisibleIcon), { key: 1 }))
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["data-field", "title", "icon", "class"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        : _createCommentVNode("", true),
      (selectedTab.value === 'styles')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockWithMetadata.value?.block?.styleFields, (field) => {
              return (_openBlock(), _createElementBlock("div", {
                key: field.value
              }, [
                (field.type === 'color')
                  ? (_openBlock(), _createBlock(PageColors, {
                      key: 0,
                      title: field.name,
                      modelValue: _ctx.section.styleValues[field.value],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.section.styleValues[field.value]) = $event)
                    }, null, 8, ["title", "modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    sidebarFooter: _withCtx(() => [
      _createVNode(cSaveButton, {
        onSave: saveBlock,
        ctaEnabled: saveButtonText.value,
        ctaDisabled: saveButtonText.value
      }, null, 8, ["ctaEnabled", "ctaDisabled"])
    ]),
    _: 1
  }))
}
}

})